<template>
  <div class="home">
    <!-- 顶栏 sticky 吸顶，随滚动方向切换 full / filter -->
    <div
      ref="topBar"
      class="goods-top"
      :class="topBarClass"
    >
      <div class="goods-top__hd">
        <PageHeader />
      </div>

      <FilterGoods
        :expert-id="expert.id"
        :default-parent-cate-ids="parentCateIds"
        :default-cate-ids="cateIds"
        :keyword="searchKeyword"
        @goGoodsSearch="goGoodsSearch"
        @filterApply="handleFilterApply"
      />
    </div>

    <!-- 热销商品 -->
    <div class="best-sellers-section">
      <div class="container">
        <div>
          <!-- 商品列表 -->
          <ProductList
            ref="productList"
            :expert-id="expert.id"
            :sortBy="sortBy"
            :parentCateIds="parentCateIds"
            :cateIds="cateIds"
            :searchKeyword="searchKeyword"
            :brands="brandName"
            :tags="tags"
            @goods-selected="handleBuyNow"
            :currencySymbol="expert.currencySymbol"
            :currencyId="expert.currencyId"
            :templateType="2"
          />
        </div>
      </div>
    </div>

    <RightFixedPanel />

    <PageFooter />
  </div>
</template>

<script>
	import homeApi from '@/api/home'
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import ProductList from '@/components/ProductList.vue';
	import CategoryList from '@/components/CategoryList.vue';
	import BrandList from '@/components/BrandList.vue';
	import SelectPurchasingPlatform from '@/components/selectPurchasingPlatform.vue';
	import PageHeader from './components/pageHeader.vue';
	import PageFooter from './components/pageFooter.vue';
	import FilterGoods from './components/filter-goods.vue';

	export default {
		name: 'Home',
		components: {
			RightFixedPanel,
			ProductList,
			CategoryList,
			BrandList,
			SelectPurchasingPlatform,
			PageHeader,
			PageFooter,
			FilterGoods
		},
		data() {
			return {
				showPlatform: 'N',
				noSelectPlatformBg: '#373737',
				selectPlatformBg: '#486AFF',
				searchKeyword: '',
				sortBy: '', //排序方式
				parentCateIds: '', //一级分类 ID
				cateIds: '', //二级分类 ID
				brandName: '', //选中的品牌名称
				tags: '', //选中的商品品质
				expert: {}, //达人信息
				storeDecoration: {}, //店铺装修信息
				storeTheme: {}, //店铺主题信息
				bgImageUrl: '', //默认背景图
				mobileBgImageUrl: '', //移动端默认背景图
				logoImageUrl: '', //PC 端默认 Logo 图
				mobileLogoImageUrl: '', //移动端默认 Logo 图
				linkImageUrls: [],
				selectPlatform: {},
				platformId: '',
				initLoading: true,
				isMobile: window.innerWidth < 768,
				currency: {},
				// 顶栏滚动：up=PageHeader+Filter，down=仅 Filter（sticky 吸顶，无 fixed 占位）
				scrollState: {
					mode: 'full',
					lastY: 0,
					phFull: 0,
					phFilter: 0
				}
			}
		},
		computed: {
			topBarClass() {
				const s = this.scrollState
				return {
					'goods-top--scrolled': s.mode === 'filter',
					'goods-top--filter': s.mode === 'filter'
				}
			}
		},
		mounted() {
			this.scrollState.lastY = this.getScrollY()
			this.$nextTick(() => this.cacheTopBarHeights())
			window.addEventListener('scroll', this.handleScroll, { passive: true })
			window.addEventListener('resize', this.onTopBarResize)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
				window.removeEventListener('resize', this.onTopBarResize)
				if (this._scrollRaf) {
					cancelAnimationFrame(this._scrollRaf)
				}
			})
		},
		watch: {
			// 监听 /goods?categoryName=xx 路由变化，同步默认分类
			'$route.query': {
				deep: true,
				handler() {
					this.syncRouteQuery();
				}
			}
		},
		async created() {
			this.syncRouteQuery();
			// 加载达人、装修主题
			await this.loadExpertConfig();
			await this.$nextTick(() => {
				var styleConfig = this.$styleManager.getCurrentConfig();
				if (styleConfig) {
					this.noSelectPlatformBg = styleConfig.backgroundColor === '#26292C' ? '#373737' :
					'#E8E8E9';
				}
				if (styleConfig) {
					this.selectPlatformBg = styleConfig.primaryColor || styleConfig.themeColor || '#486AFF';
				}

				// 处理平台选择
				if (this.expert?.expertPlatformList?.length > 0) {
					const sele = JSON.parse(sessionStorage.getItem('selectPlatform'))

					if (sele) {
						this.selectPlatform = sele
					} else {
						// 查找默认平台
						const defaultPlatform = this.expert.expertPlatformList.find(item => item.defaulted ===
							'Y')
						// 如果没有默认平台，使用第一个平台
						this.selectPlatform = defaultPlatform || this.expert.expertPlatformList[0]
					}
				}

				if (this.expert.id) {
					//加载商品分类
					if (this.$refs.categoryList && typeof this.$refs.categoryList.init === 'function') {
						this.$refs.categoryList.init();
					}
					//加载商品品牌
					if (this.$refs.brandList && typeof this.$refs.brandList.init === 'function') {
						this.$refs.brandList.init();
					}
					//加载商品列表
					if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
						this.$refs.productList.init();
					}
				}
				this.$nextTick(() => this.cacheTopBarHeights())
			});
		},
		methods: {
			// 从路由 query 同步搜索词、分类 ID
			syncRouteQuery() {
				const q = this.$route.query.keyword;
				const kw = Array.isArray(q) ? q[0] : q;
				this.searchKeyword = typeof kw === 'string' ? kw.trim() : '';

				// 一级分类 ID
				const parentCateIdQ = this.$route.query.parentCateIds || this.$route.query.parentCateId;
				const parentRaw = Array.isArray(parentCateIdQ) ? parentCateIdQ[0] : parentCateIdQ;
				this.parentCateIds = typeof parentRaw === 'string' ? parentRaw.trim() : '';

				// 二级分类 ID
				const cateIdQ = this.$route.query.cateIds || this.$route.query.cateId;
				const cateRaw = Array.isArray(cateIdQ) ? cateIdQ[0] : cateIdQ;
				this.cateIds = typeof cateRaw === 'string' ? cateRaw.trim() : '';

				if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
					this.searchByKeyword();
				}
			},

			// 加载达人、装修主题
			async loadExpertConfig() {
				try {
					const response = await homeApi.getExpertConfig();
					const {
						data
					} = response;
					this.showPlatform = data.storeShowPlatform;
					// 加载达人信息
					this.expert = data.expert;

					//设置默认LOGO
					this.logoImageUrl = data.pcLogoUrl;
					//设置移动端默认LOGO
					this.mobileLogoImageUrl = data.mobileLogoUrl;
					// 设置默认背景图
					this.bgImageUrl = data.pcBgUrl;
					// 设置移动端默认背景图
					this.mobileBgImageUrl = data.mobileBgUrl;

					document.getElementById('dynamic-favicon').href = data.domainImage;
					document.title = data.domainTitle;

					this.initLoading = false;

					// 处理店铺装修
					if (data.storeDecoration) {
						this.storeDecoration = data.storeDecoration;
						// 设置社群Link图
						if (this.storeDecoration.linkImageUrl) {
							try {
								this.linkImageUrls = JSON.parse(this.storeDecoration.linkImageUrl);
							} catch (parseError) {
								this.linkImageUrls = [];
							}
						}
					}
				} catch (error) {
					// 加载达人配置失败，请联系运营
					console.warn('Failed to load the expert configuration. Please contact the operator', error);
				}
			},

			//切换代购平台
			handleChangeExpert(platform) {
				this.selectPlatform = platform;
			},

			getScrollY() {
				return window.pageYOffset
					|| document.documentElement.scrollTop
					|| document.body.scrollTop
					|| 0
			},

			/** 缓存顶栏 full / filter 两种高度 */
			cacheTopBarHeights(force) {
				const s = this.scrollState
				if (!force && s.phFull && s.phFilter) return

				const el = this.$refs.topBar
				if (!el) return

				s.phFull = el.offsetHeight
				el.classList.add('goods-top--filter')
				s.phFilter = el.offsetHeight
				el.classList.remove('goods-top--filter')
			},

			/** 切换展示模式，高度变化时补偿 scroll */
			setBarMode(mode, scrollY) {
				const s = this.scrollState
				if (s.mode === mode) return scrollY

				this.cacheTopBarHeights()
				const oldPh = s.mode === 'full' ? s.phFull : s.phFilter
				const newPh = mode === 'full' ? s.phFull : s.phFilter
				s.mode = mode

				if (!oldPh || !newPh || newPh === oldPh) return scrollY

				const nextY = scrollY + (newPh - oldPh)
				const topSafe = 12
				if (scrollY <= topSafe || nextY <= topSafe) return scrollY

				this._scrollLock = true
				window.scrollTo(0, nextY)
				this._scrollLock = false
				return nextY
			},

			/** 根据滚动位置与方向更新顶栏展示模式 */
			updateTopBarSticky(scrollY) {
				const s = this.scrollState
				const topTh = 12
				const deltaMin = 15
				const delta = scrollY - s.lastY

				if (scrollY <= topTh) {
					if (s.mode !== 'full') {
						s.mode = 'full'
					}
					s.lastY = scrollY
					return
				}

				this.cacheTopBarHeights()
				const modeMinY = Math.max(s.phFull || 0, 80)
				let curY = scrollY
				if (Math.abs(delta) >= deltaMin && scrollY >= modeMinY) {
					const nextMode = delta > 0 ? 'filter' : 'full'
					curY = this.setBarMode(nextMode, scrollY)
				}

				s.lastY = curY
			},

			/** 窗口尺寸变化时重新缓存顶栏高度 */
			onTopBarResize() {
				this.cacheTopBarHeights(true)
			},

			handleScroll() {
				if (this._scrollLock) return
				if (this._scrollRaf) return
				this._scrollRaf = requestAnimationFrame(() => {
					this._scrollRaf = null
					const scrollY = this.getScrollY()
					this.updateTopBarSticky(scrollY)

					if (this.isMobile) {
						return
					}
					if (this.$refs.categoryList && typeof this.$refs.categoryList.init === 'function') {
						this.$refs.categoryList.hideCategoryPopup()
					}
					if (this.$refs.brandList && typeof this.$refs.brandList.init === 'function') {
						this.$refs.brandList.hideBrandPopup()
					}
				})
			},

			goGoodsSearch(keyword) {
				this.searchKeyword = keyword;
				this.searchByKeyword();
			},

      /**
       * 处理筛选条件应用
       * @param filter 筛选条件对象
       */
			handleFilterApply(filter) {
				console.log('筛选条件参数', filter);
				this.sortBy = filter.sortBy;
				// Filter 选二级/多选：parentCateIds 和 cateIds
				this.parentCateIds = filter.parentCateIds.join(',');
				this.cateIds = filter.cateIds.join(',');
				this.brandName = filter.brands.join(',');
				this.tags = filter.qualities.join(',');
				this.searchByKeyword();
			},

			searchByKeyword() {
				setTimeout(() => {
					this.$refs.productList.init();
				}, 100)
			},
		
			// 处理品牌选择
			handleBrandSelected(brand) {
				this.brandName = brand.brandName;
				this.searchByKeyword();
			},
			//社群link图跳转
			handleLink(link) {
				if (link.isLink == 'Y') {
					window.open(link.linkAddress)
				}
			},
			//立即购买
			handleBuyNow(goods) {
				if (!this.selectPlatform.platformId) {
					return this.$message.warning(this.$t('selectPlatform'));
				}
				var url = this.selectPlatform.platformUrl;
				if (url.indexOf('{goodId}') != -1) {
					url = url.replace('{goodId}', goods.weidianGoodsId);
				}
				if (url.indexOf('{weidian}') != -1) {
					url = url.replace('{weidian}', goods.weidianId);
				}
				if (url.indexOf('{inviteCode}') != -1) {
					url = url.replace('{inviteCode}', this.selectPlatform.invitationCode);
				}
				window.open(url);
			}
		}
	}
</script>

<style scoped>
	:deep .el-dialog--center .el-dialog__body {
		padding: 0 20px;
	}

	.home {
		width: 100%;
		min-height: 100vh;
		background-color: var(--background-color);
	}

	/* 顶栏 sticky 吸顶，避免 fixed+占位首次滚动抖一下 */
	.goods-top {
		position: sticky;
		top: 0;
		z-index: 100;
		width: 100%;
		background-color: var(--background-color);
	}

	.goods-top--scrolled {
		box-shadow: 0 4px 12px hsl(from var(--background-color) h s l / 0.35);
	}

	.goods-top--filter .goods-top__hd {
		display: none;
	}

	.container {
		margin: 0 auto;
		width: 100%;
		max-width: 1200px;
		padding: 0 20px;
	}

	.hero {
		max-width: none;
		padding: 0 !important;
		position: relative;
		width: 100%;
	}

	.bg-image {
		width: 100%;
		height: 300px;
	}

	.platform {
		color: var(--link-color);
		margin: 0 8px;
	}

	/* 顶部Logo、社群Link样式 */
	.logo-link {
		position: absolute;
		bottom: 25px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		max-width: 1200px;
		padding: 0;
		height: 300px;
		padding-right: 40px;
	}

	.logo-img {
		width: 100%;
		max-width: 400px;
		height: auto;
		max-height: 170px;
		border-radius: 10px;
	}

	.link-img {
		width: 100%;
		max-width: 250px;
		height: auto;
		max-height: 35px;
		border-radius: 10px;
		margin-top: 5px;
		cursor: pointer;
	}

	.search-layout {
		display: flex;
		flex-direction: column;
	}

	.search-sub-layout {
		display: flex;
		align-items: center;
		width: 100%;
		max-width: 1200px;
	}

	.search-container {
		display: flex;
		justify-content: center;
		z-index: 10;
		flex-direction: column;
	}

	.search-wrapper {
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 4px;
		width: 80%;
		overflow: hidden;
	}

	.search-button {
		color: white;
		border: none;
		height: 42px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	.platform-left {
		margin-left: 10px;
	}

	/* 悬浮弹窗样式 */
	.popup-layout {
		max-height: 300px;
		overflow-y: auto;
		/* 滚动条美化 */
		scrollbar-width: thin;
	}

	.popup-content {
		gap: 10px;
		padding: 15px 0;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.platform-filter {
		padding: 10px 20px;
		border-radius: 10px;
		color: var(--link-color);
		cursor: pointer;
		font-size: 17px;
		transition: all 0.3s ease;
		flex-shrink: 0;
		white-space: nowrap;
		position: relative;
		z-index: 9998 !important;
		/* 确保分类过滤器不会裁剪下拉菜单 */
		overflow: visible !important;
		display: flex;
		align-items: center;
	}

	.platform-filter-img {
		width: 30px;
		height: 30px;
		border-radius: 8px;
	}

	.platform-filter.active {
		font-weight: bold;
		color: #fff;
		background: var(--primary-color);
	}

	/* 响应式调整 */
	@media (max-width: 1200px) {
		.logo-link {
			padding: 0;
			width: 95%;
		}

		.search-layout {
			padding: 0 10px 0 0;
		}
	}

	@media (max-width: 768px) {
		.bg-image {
			height: 250px;
		}

		.logo-link {
			align-items: center;
			gap: 0;
			left: 0;
			padding: 0 10px;
			bottom: 30px;
			width: 100%;
		}

		.search-sub-layout {
			flex-direction: column;
			align-items: stretch;
			gap: 10px;
		}

		.custom-search-input {
			width: 100%;
		}

		.search-button {
			width: 100px;
		}

		.logo-img {
			width: 80px;
			height: 80px;
			border-radius: 100px;
			border: 3px solid var(--primary-color);
		}

		.link-img {
			width: 250px;
			height: 28px;
		}

		.search-wrapper {
			padding: 15px;
		}
	}

	@media (max-width: 480px) {
		.container {
			padding: 0 10px;
		}

		.platform-filter {
			font-size: 15px;
			padding: 5px 10px;
		}

		.platform-filter-img {
			width: 22px;
			height: 22px;
		}

		.logo-img {
			max-width: 200px;
			max-height: 100px;
		}

		.link-img {
			width: 250px;
			height: 28px;
			margin-top: 0;
		}

		.search-layout {
			padding: 0;
		}

		.search-wrapper {
			padding: 10px;
		}

		.search-button {
			font-size: 15px;
			height: 42px;
		}

		.platform-left {
			margin-left: 0;
		}

		:deep .el-select {
			width: 100%;
		}

		:deep .el-input__inner {
			height: 40px;
			font-size: 15px;
		}

		:deep .el-input__icon {
			line-height: 40px;
		}

		:deep .el-input--prefix input {
			font-size: 16px;
		}
	}

	:deep .search-input,
	:deep.search-input input {
		border-radius: 0 !important;
		border: 1px solid var(--border-color) !important;
		border-right: none !important;
	}

	:deep .el-input__prefix {
		display: flex;
		align-items: center;
	}

	:deep .el-input--prefix input {
		padding-left: 35px !important;
	}
</style>